import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e86173f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notes-container" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "text-end"
}
const _hoisted_4 = { class: "notes-counts fw-bold" }
const _hoisted_5 = { class: "notes-count" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_7 = { class: "notes-limit" }
const _hoisted_8 = ["data-bs-original-title"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("textarea", {
      class: "notes-area",
      placeholder: "Comments",
      onKeyup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.processNotes($event))),
      value: this.notesMessage
    }, null, 40, _hoisted_2),
    (this.showCharacterStats)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(this.notesCount), 1),
            _hoisted_6,
            _createElementVNode("span", _hoisted_7, _toDisplayString(this.notesLimit), 1),
            _createElementVNode("span", {
              hidden: "",
              class: "notes-error text-red",
              "data-bs-toggle": "tooltip",
              "data-bs-placement": "top",
              "data-bs-original-title": this.notesLimitErrorMessage
            }, _hoisted_10, 8, _hoisted_8)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}